// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setGenerateModalSelectedFolderableOperation = createAction('[Generate Modal] Set Selected Folderable Operation', props());
